import { ProjectDetailsPage, ProjectsPage } from './pages';

export const projectsRoutes = [
  {
    path: 'projects',
    component: ProjectsPage,
    requiredPermission: 'projects.view',
  },
  {
    path: 'projects/:projectId',
    component: ProjectDetailsPage,
    requiredPermission: 'projects.view',
  },
];
